import React, {Component} from 'react';
import {Button, Modal, ModalBody} from 'reactstrap';
import {connect} from 'react-redux'
import axios from 'axios';
import {resetIngredient} from '../../../../redux/ActionCreaters';
import Spinner from '../../../Spinner/Spinner';

const mapStateToProps=state=>{
    return{
        ingredient:state.ingredient,
        totalPrice:state.totalPrice,
        userId:state.userId,
        token:state.token
    }
}

const mapDispatchToProps=dispatch=>{
    return{
        resetIngredient:()=>dispatch(resetIngredient())
    }
}
class Checkout extends Component{

    state={
        values:{
            address:"",
            phone:"",
            delivery:"Cash on delivery"
        }
        ,
        isLoading:false,
        isModalOpen:false,
        ModalMsg:"",
    }

    inputChangeHandle=(e)=>{
        this.setState({
            values:{
                ...this.state.values,
                [e.target.name]:e.target.value
            }
        })
    }
    onSubmit=()=>{
        this.setState({
            isLoading:true,
        })
        const order={
            ingredient:this.props.ingredient,
            customer:this.state.values,
            totalPrice:this.props.totalPrice,
            orderTime: new Date(),
            userId:this.props.userId
        }
        console.log(order);
        axios.post("https://burger-builder-3abd7-default-rtdb.firebaseio.com/orders.json?auth="+this.props.token,order)
        .then(res => {
            if(res.status===200){
                this.setState({
                    isLoading:false,
                    ModalMsg:"Order submitted successfully!",
                    isModalOpen:true,
                    

                })
                this.props.resetIngredient();
            }
            else{
                this.setState({
                    isLoading:false,
                    ModalMsg:"Order submitted failed!please try again!",
                    isModalOpen:true
                })
            }
        })
        .catch(err => {
            this.setState({
                isLoading:false,
                ModalMsg:"Order submitted failed!please try again!",
                isModalOpen:true
            })
        })
    }

    goBack=()=>{
        this.props.history.goBack("/")
    }

    render(){
        let form=(<div>
            <div className="container">
                <div className="form-control border font-weight-bold mb-4">Total Price : {this.props.totalPrice} BDT</div>
                <form className="form border p-5">
                    <textarea cols="100" rows="5" className="form-control mb-3" name="address" value={this.state.values.address} placeholder="Your address" onChange={(e)=>this.inputChangeHandle(e)}  ></textarea>
                    <input type="tel" className="form-control mb-3" name="phone" placeholder="your phone number" onChange={(e)=>this.inputChangeHandle(e)}  value={this.state.values.phone} />
                    <select type="select" className="form-control mb-3" name="delivery" onChange={(e)=>this.inputChangeHandle(e)}  value={this.state.values.delivery}  >
                        <option value="Cash on delivery" key="">Cash on delivery</option>
                        <option value="bKash" key="">bKash</option>
                    </select>
                    <Button className="mr-1" color="primary" onClick={this.onSubmit}>Place order</Button>
                    <Button onClick={this.goBack}>Cancel</Button>
                </form>
            </div>
        </div>);
        return(
            <div>
                { this.state.isLoading? <Spinner/> : form }
                <Modal isOpen={this.state.isModalOpen} onClick={this.goBack}>
                    <ModalBody>{this.state.ModalMsg}</ModalBody>
                </Modal>
            </div>
        )
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Checkout);